module.exports = __webpack_public_path__ + "assets/5ccab6fac12405ff5f45114df094f98f.png";